module.exports = __webpack_public_path__ + "img/symbol_3.7e05ccf5.png";